import PropTypes from 'prop-types'
import { Edit, TrashAlt, AddToQueue } from '@styled-icons/boxicons-solid'
import { formatEmptyValue } from '../../../utils/common'
import Tooltip from '../../common/tooltip'

const HarnessRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-4/12  pl-10 items-center table_text">
          <Tooltip message={formatEmptyValue(props.harness_id)}>
            {formatEmptyValue(props.harness_id)}
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={formatEmptyValue(props.part_number)}>
            {formatEmptyValue(props.part_number)}
          </Tooltip>
        </div>
        <div className="w-2/12 pl-6 items-center table_text">
          <Tooltip message={formatEmptyValue(props.abbreviation)}>
            {formatEmptyValue(props.abbreviation)}
          </Tooltip>
        </div>
        <div className="w-2/12 pl-6 items-center table_text">
          <Tooltip message={formatEmptyValue(props.base_part_number)}>
            {formatEmptyValue(props.base_part_number)}
          </Tooltip>
        </div>

        <div className="flex w-2/12 pl-6 justify-end items-center">
          <span className="cursor-pointer">
            <AddToQueue
              size="2rem"
              color="#0189E9"
              onClick={() => {
                props.showRelatedData()
              }}
            />
          </span>
          <div>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
          </div>
          <div>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <TrashAlt size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

HarnessRow.propTypes = {
  harness_id: PropTypes.string.isRequired,
  part_number: PropTypes.string.isRequired,
  abbreviation: PropTypes.string,
  description: PropTypes.string,
  base_part_number: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
}

export default HarnessRow
